export enum SidebarDataHooks {
  ROOT = 'sidebar',
  CTA = 'sidebar-cta',
}
